module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-3-a8bee1853e60f733aa7c5bb083db7bbf.svg";